import React from "react";
import Grid from "@mui/material/Grid2";
import SuiBox from "components/SuiBox";
import DashboardLayout from "common/LayoutContainers/DashboardLayout";
import DashboardNavbar from "common/Navbars/DashboardNavbar";
import Footer from "common/Footer";
import SedesTable from "./components/sedesTable";

const SedesAdmin = () => {
  return (
    <DashboardLayout>
      <DashboardNavbar />
      <SuiBox mt={4} mb={3}>
        <Grid size={12}>
          <Grid xs={12}>
            <SedesTable />
          </Grid>
        </Grid>
      </SuiBox>
      <Footer />
    </DashboardLayout>
  );
};

export default SedesAdmin;
